import { Box, Chip, Tooltip } from "@mui/material"
import type { FC } from "react"

interface DistributorCellProps {
  distributors?: { externalSystemId: string; name: string }[] | null
}

const MAX_VISIBLE_DISTRIBUTORS = 2

export const DistributorCell: FC<DistributorCellProps> = ({ distributors }) => {
  if (!distributors || distributors.length === 0) {
    return null
  }

  const visibleDistributors = distributors.slice(0, MAX_VISIBLE_DISTRIBUTORS)
  const hiddenDistributors = distributors.slice(MAX_VISIBLE_DISTRIBUTORS)
  const hasMore = hiddenDistributors.length > 0

  return (
    <Box className='flex flex-wrap items-center gap-2'>
      {visibleDistributors.map((distributor) => (
        <Chip
          key={distributor.externalSystemId}
          label={distributor.name}
          size='small'
          className='rounded bg-orange-100 text-xs text-blue-gray-800'
        />
      ))}
      {hasMore && (
        <Tooltip
          title={
            <Box className='flex flex-col gap-1'>
              {hiddenDistributors.map((distributor) => (
                <div key={distributor.externalSystemId}>{distributor.name}</div>
              ))}
            </Box>
          }
        >
          <Chip label='...' size='small' className='rounded bg-orange-100 text-xs text-blue-gray-800' />
        </Tooltip>
      )}
    </Box>
  )
}
